The type of the component.

Currently, two codes are defined:

- `Question` corresponds to the `question` field.
- `PrivacyConsent` corresponds to the `privacyConsent` field.
